import { Box, Pagination, TableRow, TextField, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAgenda } from '../../redux/actions/agenda.actions'

import { Copy } from '@phosphor-icons/react'
import ClipLoader from 'react-spinners/ClipLoader'
import { useGetUser } from '../../hooks/useGetUser'
import { Button } from '../../shared/button/button'
import { Loader } from '../../shared/loader/loader'
import {
  NormalText,
  RowStyled,
  TableBodyStyled,
  TableCellStyled,
  TableHeadStyled,
  TableStyled,
  TitleStyled,
  TooltipStyled,
} from '../../shared/styles'
import { copyToClipboard, formatLargeText } from '../../shared/utils'
import { ModalCreateEditContact } from './modal-create-edit-contact'
import { ModalDeleteContact } from './modal-delete-contact'

export const AgendaContainer = () => {
const [apellidoFilter, setApellidoFilter] = useState('')
  const [showModals, setShowModals] = useState({
    createContact: false,
    editContact: false,
    deleteContact: false,
  })
  const [contactSelected, setContactSelected] = useState(null)

  const {
    data: agenda,
    isLoading: isLoadingAgenda,
    pagination: paginationAgenda,
    error,
  } = useSelector((state) => state.agenda)

  const { user } = useGetUser()
  const { palette } = useTheme()
  const dispatch = useDispatch()

  function handleShowModal(modal) {
    setShowModals({ ...showModals, [modal]: !showModals[modal] })
  }

  function handleDeleteContact(contact) {
    setShowModals({ ...showModals, deleteContact: true })
    setContactSelected(contact)
  }

  function handleEditContact(contact) {
    setShowModals({ ...showModals, editContact: true })
    setContactSelected(contact)
  }
  useEffect(() => {
    if (user?.usuarioid) {
      dispatch(getAgenda(user.usuarioid, 1, 10, apellidoFilter))
    }
  }, [dispatch, user?.usuarioid, apellidoFilter])
  if (error)
    return (
      <NormalText color={'#EA7A7A'} size={14}>
        Error loading agenda
      </NormalText>
    )

  return (
    <Box>
      <ModalCreateEditContact
        open={showModals?.createContact || showModals?.editContact}
        handleClose={handleShowModal}
        idContact={contactSelected?.idwallet}
        contactData={contactSelected}
        isEdit={showModals?.editContact}
        userId={user?.usuarioid}
      />
      <ModalDeleteContact
        open={showModals?.deleteContact}
        handleClose={handleShowModal}
        idContact={contactSelected?.idwallet}
        userId={user?.usuarioid}
      />
      <Box display="flex" alignItems="center" gap={'24px'}>
        <TitleStyled>Agenda</TitleStyled>
        <Button
          label={
            isLoadingAgenda ? (
              <Loader size={16} color="#0197f6" />
            ) : (
              'Create contact'
            )
          }
          endIcon={!isLoadingAgenda && 'PlusCircle'}
          onClick={() => handleShowModal('createContact')}
          buttonStyles={{ minWidth: '162px' }}
          containerStyles={{
            maxHeight: '39px',
          }}
        />
        <TextField
          label="Filter by last name"
          value={apellidoFilter}
          onChange={(e) => setApellidoFilter(e.target.value)}
          size="small"
          sx={{ minWidth: 220 }}
        />
      </Box>
      <Box
        display={'flex'}
        flexWrap={'wrap'}
        gap={'8px'}
        mt={'24px'}
        justifyContent={'space-between'}
      >
        {isLoadingAgenda ? (
          <ClipLoader color={'#0197f6'} size={24} />
        ) : agenda.length > 0 ? (
          <>
            <TableStyled>
              <TableHeadStyled>
                <TableRow>
                  <TableCellStyled align="center">Alias</TableCellStyled>
                  <TableCellStyled align="center">Email</TableCellStyled>
                  <TableCellStyled align="center">Name</TableCellStyled>
                  <TableCellStyled align="center">Last name</TableCellStyled>
                  <TableCellStyled align="center">Address</TableCellStyled>
                  <TableCellStyled align="center">Actions</TableCellStyled>
                </TableRow>
              </TableHeadStyled>
              <TableBodyStyled>
                {agenda.map((contact) => (
                  <RowStyled
                    key={contact.idwallet}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCellStyled align="center">
                      {contact.alias}
                    </TableCellStyled>
                    <TableCellStyled align="center">
                      {formatLargeText(contact.email || '-', 20)}
                    </TableCellStyled>
                    <TableCellStyled align="center">
                      {contact.nombre || '-'}
                    </TableCellStyled>
                    <TableCellStyled align="center">
                      {contact.apellido || '-'}
                    </TableCellStyled>
                    <TableCellStyled align="center">
                      <Box
                        display={'flex'}
                        gap={'8px'}
                        alignItems={'center'}
                        justifyContent={'center'}
                      >
                        <TooltipStyled
                          title={contact.walletadress}
                          placement="top"
                        >
                          <NormalText size={14} color={'#272A24'}>
                            {formatLargeText(contact.walletadress || '-', 45)}
                          </NormalText>
                        </TooltipStyled>
                        <TooltipStyled title="Copy" placement="top">
                          <Copy
                            color={'#8C8C8C'}
                            size={16}
                            onClick={() =>
                              copyToClipboard(contact.walletadress)
                            }
                            style={{
                              cursor: 'pointer',
                            }}
                          />
                        </TooltipStyled>
                      </Box>
                    </TableCellStyled>
                    <TableCellStyled align="center">
                      <Box
                        display={'flex'}
                        gap={'8px'}
                        alignItems={'center'}
                        justifyContent={'center'}
                      >
                        <Button
                          type={'regular'}
                          iconColor={palette.primary.main}
                          startIcon={'PencilSimple'}
                          onClick={() => handleEditContact(contact)}
                          tooltipLabel={'Edit'}
                          buttonStyles={{
                            '&&:hover': {
                              svg: {
                                fill: `${palette.secondary.main} !important`,
                              },
                            },
                          }}
                        />
                        <Button
                          type={'regular'}
                          iconColor={palette.error.main}
                          startIcon={'Trash'}
                          onClick={() => handleDeleteContact(contact)}
                          tooltipLabel={'Delete'}
                          buttonStyles={{
                            '&&:hover': {
                              svg: {
                                fill: `${palette.secondary[2]} !important`,
                              },
                            },
                          }}
                        />
                      </Box>
                    </TableCellStyled>
                  </RowStyled>
                ))}
              </TableBodyStyled>
            </TableStyled>
            {paginationAgenda?.lastPage > 1 && (
              <Box
                display={'flex'}
                justifyContent={'center'}
                mt={'8px'}
                width={'100%'}
              >
                <Pagination
                  count={paginationAgenda?.lastPage}
                  page={paginationAgenda?.page}
                  onChange={(_, value) => {
                    dispatch(getAgenda(user?.usuarioid, value,10, apellidoFilter))
                  }}
                  size="large"
                  sx={{ alignSelf: 'center', marginTop: '8px' }}
                />
              </Box>
            )}
          </>
        ) : (
          <NormalText size={14}>No contacts found</NormalText>
        )}
      </Box>
    </Box>
  )
}
